<template>
  <div class="dev">
    <app-checkbox-group
      v-if="answers.length"
      :key="`question-${0}`"
      v-model="value"
      :levels="answers"
      item-text="answer"
      @changeRadioButton="clickButton()"
    />
  </div>
</template>

<script>
import AppCheckboxGroup from '@/components/Forms/AppCheckboxGroup.vue';
import calcResult from '@/utils/calcResults';

const test = {
  base: {
    showResult: true,
    crmId: 1,
    name: 'Пробный тест 1',
    url: '/olololo/',
    header: 'qwerty',
    button: 'ОЛОО Копка',
    description: 'Тестирование – это лишь инструмент для понимания себя, а не инструкция к жизни. Реально спроектировать будущее на основе теста можно только в диалоге со специалистом. Консультанты MAXIMUM помогают выбрать профильные предметы, специальность и университет для поступления. Пройди тест и получи консультацию со специалистом MAXIMUM — бесплатно. Отвечай честно и не задумываясь, чтобы результат теста точнее соответствовал твоим склонностям. Время прохождения теста ~15 минут.',
  },
  finish: {
    title: 'Тест окончен',
    description: '13 1к 2а 3 3а3 ааыавававыаа',
    video: '/video-url/',
    button: 'Кнопка',
    link: '/aaaaaaaaaa/',
  },
  lastId: {
    category: 3,
    question: 3,
    answer: 9,
    result: 2,
    answerTemplate: 3,
    otherResultsGroup: 2,
    otherResultsItem: 6,
  },
  results: {
    name: 'Характер',
    categoriesNumber: 2,
    items: [
      {
        categoriesIdList: [
          1,
          2,
        ],
        otherItemIdList: [1, 2, 4, 6],
        id: 2,
        name: 'Комсомолец',
      },
      {
        categoriesIdList: [
          1,
          3,
        ],
        otherItemIdList: [4, 5, 3, 6],
        id: 1,
        name: 'Розбiiник',
      },
    ],
  },
  otherResults: {
    groups: [
      {
        itemsIdList: [5, 4, 1],
        id: 2,
        name: 'Егэ',
      },
      {
        itemsIdList: [6, 3, 2],
        id: 1,
        name: 'Вуз',
      },
    ],
    items: [
      {
        id: 6,
        name: 'РГСУ',
      },
      {
        id: 5,
        name: 'Литература',
      },
      {
        id: 4,
        name: 'Математика',
      },
      {
        id: 3,
        name: 'МГУ',
      },
      {
        id: 2,
        name: 'МФТИ',
      },
      {
        id: 1,
        name: 'Физика',
      },
    ],
  },
  _id: '5e85b91245835a4ad8ac5031',
  type: 'WithWeigth',
  categories: [
    {
      id: 3,
      name: 'Трудолюбие',
    },
    {
      id: 2,
      name: 'Честность',
    },
    {
      id: 1,
      name: 'Стрессоустойчивость',
    },
  ],
  questions: [
    {
      id: 3,
      text: 'Спишь на уроках?',
    },
    {
      id: 2,
      text: 'Воруешь вишню у соседей?',
    },
    {
      id: 1,
      text: 'Любишь копать картошку?',
    },
  ],
  answers: [
    {
      categoriesIdList: [
        1,
        3,
      ],
      id: 9,
      questionId: 3,
      templateId: 1,
    },
    {
      categoriesIdList: [
        1,
        2,
      ],
      id: 8,
      questionId: 3,
      templateId: 2,
    },
    {
      categoriesIdList: [
        1,
        3,
      ],
      id: 7,
      questionId: 3,
      templateId: 3,
    },
    {
      categoriesIdList: [
        1,
        2,
      ],
      id: 6,
      questionId: 2,
      templateId: 1,
    },
    {
      categoriesIdList: [
        2,
        1,
      ],
      id: 5,
      questionId: 2,
      templateId: 2,
    },
    {
      categoriesIdList: [
        1,
        2,
      ],
      id: 4,
      questionId: 2,
      templateId: 3,
    },
    {
      categoriesIdList: [
        3,
        2,
      ],
      id: 3,
      questionId: 1,
      templateId: 1,
    },
    {
      categoriesIdList: [
        3,
        2,
      ],
      id: 2,
      questionId: 1,
      templateId: 2,
    },
    {
      categoriesIdList: [
        3,
        2,
      ],
      id: 1,
      questionId: 1,
      templateId: 3,
    },
  ],
  answerTemplates: [
    {
      id: 3,
      text: 'Да',
      weight: 3,
    },
    {
      id: 2,
      text: 'Наверное',
      weight: 2,
    },
    {
      id: 1,
      text: 'Нет',
      weight: 1,
    },
  ],
  createdAt: '2020-04-02T10:06:10.347Z',
  updatedAt: '2020-04-02T10:06:56.216Z',
};

const answers = [1, 3, 9];

export default {
  name: 'DevPage',
  components: {
    AppCheckboxGroup,
  },
  data() {
    return {
      answers: [
        {
          id: 0,
          text: 'Да',
        },
        {
          id: 1,
          text: 'Наверное',
        },
        {
          id: 2,
          text: 'Нет',
        },
      ],
      value: [],
    };
  },
  created() {
    console.log(calcResult(test, answers));
  },
};
</script>
